import { config_obj } from './firebase'

export function load_analytics(){
  let segment_key
  if (!config_obj || !config_obj.firebase || !config_obj.firebase.projectId) return false

  if (config_obj.firebase.projectId === 'promoboxx-production') {
    segment_key = '3ub709BJqezSWR5WfHv208eJVqWZNdOj'
  } else if (config_obj.firebase.projectId === 'promoboxx-stg' || config_obj.firebase.projectId === 'promoboxx-dev-pine') {
    segment_key = 'WPuIXiiBJnG9AwkuYaleoN9vu89ogB6U'
  }

  if (segment_key) {
    let script_element = document.createElement('script')

    script_element.text = !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
  
    analytics.load(segment_key);
    analytics.page();
  
    }}();
  }

}